module.exports = __webpack_public_path__ + "img/violet_066.b87afaa8.png";